(() => {
  function init() {
    const menus = [...document.querySelectorAll('.frx-mm-details')];
    const desktop = matchMedia('(min-width:990px)');
    const close = (d, focus = false) => {
      d.open = false;
      d.closest('li').classList.remove('is-open');
      d.querySelector('summary').setAttribute('aria-expanded', 'false');
      if (focus) d.querySelector('summary').focus();
    };
    const open = d => {
      menus.forEach(other => { if (other !== d) close(other); });
      d.open = true;
      d.closest('li').classList.add('is-open');
      d.querySelector('summary').setAttribute('aria-expanded', 'true');
    };
    menus.forEach(d => {
      if (d.dataset.refinedReady) return;
      d.dataset.refinedReady = 'true';
      const summary = d.querySelector('summary');
      summary.setAttribute('aria-expanded', String(d.open));
      summary.addEventListener('click', e => {
        if (!desktop.matches) return;
        e.preventDefault();
        e.stopPropagation();
        d.open ? close(d) : open(d);
      });
      d.querySelector('.frx-mm__close')?.addEventListener('click', () => close(d, true));
      d.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (!d.contains(document.activeElement)) close(d); });
      });
    });
    document.addEventListener('click', e => {
      menus.forEach(d => { if (d.open && !d.contains(e.target)) close(d); });
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') menus.forEach(d => { if (d.open) close(d, true); });
    });
    document.querySelectorAll('.frx-hero').forEach(hero => {
      const video = hero.querySelector('video');
      const toggle = hero.querySelector('.frx-hero__toggle');
      if (!video || !toggle) return;
      const motion = matchMedia('(min-width:990px) and (prefers-reduced-motion:no-preference)');
      const update = () => {
        hero.classList.toggle('frx-video-playing', !video.paused);
        toggle.hidden = !motion.matches;
        toggle.setAttribute('aria-label', video.paused ? 'Spela video' : 'Pausa video');
        toggle.firstElementChild.textContent = video.paused ? '▶' : 'Ⅱ';
      };
      const configure = () => {
        if (motion.matches) {
          if (!video.src) video.src = video.dataset.videoSrc;
          video.play().catch(update);
        } else video.pause();
        update();
      };
      toggle.addEventListener('click', () => {
        if (video.paused) video.play().catch(update); else video.pause();
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      motion.addEventListener('change', configure);
      configure();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
